export default function assert(callback: () => boolean) {
  if (
    process.env.NODE_ENV === "development" ||
    process.env.NODE_ENV === "test"
  ) {
    if (!callback()) {
      throw new Error("Assert failed.");
    }
  }
}

/**
 * Assert array uniqueness. Uses === to compare array items.
 *
 */
assert.uniqueArray = function (arr: any[]) {
  assert(() => {
    for (let i = 0; i < arr.length - 1; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i] === arr[j]) {
          return false;
        }
      }
    }
    return true;
  });
};
